export function header() {

    let $body = $("body");
    let topPosition = 0;
    let $win = $(window);
    let $menuBtn = $(".menu-btn");
    let $header = $(".header");
    let $navList = $(".nav-list");
    let $dropItem = $navList.find(".has-dropdown");
    let $dropBtn = $dropItem.find(".nav-corner");
    let $dropNav = $dropItem.find(".nav-item");
    let $nav = $(".header-inner").find("nav");

    let disableScroll = () => {
        topPosition = $(window).scrollTop();

        $body.css({
            "position": "fixed",
            "top": -topPosition + "px",
            "width": "100%",
            "height": "auto",
            "overflow": "hidden",
        });
    };

    $menuBtn.on("click", function () {
        $body.toggleClass("open-menu");

        if ($body.hasClass("open-menu")) {
            disableScroll();
        } else {
            $body.css({
                "position": "",
                "top": "",
                "width": "",
                "height": "",
                "overflow": "",
            });

            $(window).scrollTop(topPosition);
        }
    });

    if ($body.hasClass("no-touch")) {
        $dropNav.on("mouseenter", function () {
            if ($(document).width() >= 1200) {
                let $parent = $(this).closest(".has-dropdown");
                let items = $parent.siblings();

                if (!$parent.hasClass("is-active")) {
                    items.removeClass("is-active").find(".nav-dropdown").slideUp();
                }

                $parent.addClass("is-active").find(".nav-dropdown").slideDown();
            }
        });

        $dropItem.on("mouseleave", function () {
            if ($(document).width() >= 1200) {
                let $parent = $(this).closest(".has-dropdown").removeClass("is-active");
                $parent.find(".nav-dropdown").slideUp();
            }
        });
    } else {
        $dropBtn.on("click", function (e) {
            e.preventDefault();

            let $parent = $(this).closest(".has-dropdown");
            let items = $parent.siblings();

            if (!$parent.hasClass("is-active")) {
                items.removeClass("is-active").find(".nav-dropdown").slideUp();
            }
            $parent.toggleClass("is-active").find(".nav-dropdown").slideToggle();
        });
    }

    if ($(document).width() >= 1200) {
        $nav.appendTo(".header-inner");
        $nav.addClass("moved");
    }

    if ($win.scrollTop() > 0) {
        $header.addClass("colored");
    }

    $win.on("scroll", function () {
        if ($win.scrollTop() > 0) {
            $header.addClass("colored");
        } else {
            $header.removeClass("colored");
        }
    });

    $win.on("resize", function () {
        if ($(document).width() >= 1200 && !$nav.hasClass("moved")) {
            $nav.appendTo(".header-inner");
            $nav.addClass("moved");
            $nav.removeClass("moved-back");
        }

        if ($(document).width() < 1200 && !$nav.hasClass("moved-back")) {
            $nav.appendTo(".header-right-inner");
            $nav.removeClass("moved");
            $nav.addClass("moved-back");
        }
    });

    $win.on("wheel", function (e){

        if ($win.width() >= 1200) {
            if (e.originalEvent.wheelDelta >= 8 && e.originalEvent.wheelDelta > 0){
                $header.removeClass("hide");
            } else if (e.originalEvent.wheelDelta < 0 && e.originalEvent.wheelDelta <= -7) {
                $header.addClass("hide");
            }
        }
    });

    setTimeout(() => {
        $header.removeClass("hide");
    }, 400);
}


// WEBPACK FOOTER //
// ./assets/js/modules/header.js